import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ErrorHandlerService } from '../services/app-error-handler.service';
import { NotificationService } from '../services/notification.service';
import { SKIP_ERROR_PAGE } from '../constants/http-context.constants';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const router = inject(Router);
  const notifications = inject(NotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 409) {
        return throwError(() => error);
      }

      const errorMessage = errorHandler.handle(error);

      console.error('API Error:', {
        url: req.url,
        method: req.method,
        status: error.status,
        message: errorMessage,
        error,
      });

      if ((error.status === 401 || error.status === 403) && !req.context.get(SKIP_ERROR_PAGE)) {
        void router.navigate(['/unauthorized']);
      } else {
        // Notify only: navigating away would destroy the page and cancel its sibling requests.
        notifications.showError('Request failed', errorMessage);
      }

      return throwError(() => error);
    }),
  );
};
